import React, { FC } from "react";
import Svg, { Circle, G, Path } from "react-native-svg";
import { ICustomSvgProps } from "./AngryIcon";

const HappyIcon: FC<ICustomSvgProps> = (props) => {
  return (
    <Svg width={props.width} height={props.height} viewBox="0 0 313 313">
      <G transform="translate(-52.3109, -44.8266)">
        <Circle
          cx="208.495"
          cy="201.01"
          r="156.184"
          fill={props.color || "rgb(210,220,86)"}
        />
      </G>
      <G transform="translate(-59.3665, -36.7654)">
        <G transform="matrix(-0.6192, 0.59853, -0.59853, -0.6192, 158.895, 158.956)">
          <Circle
            cx="0"
            cy="0"
            r="15.908"
            stroke={props.strokeColor || "black"}
            strokeWidth="15.1px"
          />
        </G>
        <G transform="matrix(-0.6192, 0.59853, -0.59853, -0.6192, 272.205, 161.124)">
          <Circle
            cx="0"
            cy="0"
            r="15.908"
            stroke={props.strokeColor || "black"}
            strokeWidth="15.1px"
          />
        </G>
      </G>
      <G transform="matrix(-1,0,0,-1,372.913,441.247)">
        <Path
          d="M164.604,250.133 C166.65,223.147 189.223,201.857 216.729,201.857 C244.236,201.857 266.809,223.147 268.854,250.133"
          fill="none"
          stroke={props.strokeColor || "black"}
          strokeWidth="20px"
        />
      </G>
    </Svg>
  );
};

export default HappyIcon;
